import React, { useMemo, useState } from "react";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SubMenu,
} from "react-pro-sidebar";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { SidebarFooterLink, SidebarStyle } from "./Sidebar.style";
import Logo from "assets/icons/Logo";
import Burger from "assets/icons/Burger";
import { SideItems } from "./SideItems";
import { IPropsT, ISideItemsChildrenT, ISideItemsT } from "./Sidebar.types";
import Employee from "assets/icons/Employee";
import "react-pro-sidebar/dist/css/styles.css";

const Sidebar = ({ collapse, setCollapse }: IPropsT) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = useMemo(() => {
    let user: { _id?: string } | null = null;
    try {
      const admin = localStorage.getItem("admin") || null;
      if (admin) user = JSON.parse(admin);
    } catch {
      // ignore
    }
    const currentUserId = user?._id;
    return SideItems.filter((item) => {
      if (!item.showOnlyForUserId) return true;
      return currentUserId === item.showOnlyForUserId;
    });
  }, []);


  return (
    <SidebarStyle>
      <ProSidebar collapsed={collapse} breakPoint="md">
        <SidebarHeader>
          <div className="sidebar-header">
            <div className="d-flex align-items-center">
              {/* {!collapse && <Logo className="logo" />} */}
              {!collapse && <p style={{ color: "white" }}>Edu School</p>}
              <div
                className={`burger ${collapse ? "rotate-burger" : ""}`}
                onClick={() => setCollapse(!collapse)}
              >
                <Burger />
              </div>
            </div>
          </div>
        </SidebarHeader>
        <SidebarContent>
          <Menu iconShape="circle">
            {menuItems.map((item: ISideItemsT) => {
              return item.children ? (
                // @ts-ignore
                <SubMenu
                  key={item.id}
                  title={String(t(`COMMON.${item.title}`))}
                  icon={item.icon}
                >
                  {item.children.map((children: ISideItemsChildrenT) => {
                    return (
                      <MenuItem
                        key={children.id}
                        className={`text-black`}
                        active={
                          location.pathname === children.path ||
                          !!children?.insidePaths?.find(
                            (path: string) =>
                              path === location.pathname ||
                              path === location.pathname.slice(0, -25)
                          )
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          if (location.pathname !== children.path) {
                            navigate(children.path);
                          }
                        }}
                      >
                        {t([`COMMON.${children.title}`])}
                      </MenuItem>
                    );
                  })}
                </SubMenu>
              ) : (
                <MenuItem
                  key={item.id}
                  className={`text-black`}
                  icon={item.icon}
                  active={
                    location.pathname === item.path ||
                    !!item?.insidePaths?.find(
                      (path: string) =>
                        path === location.pathname ||
                        path === location.pathname.slice(0, -25)
                    )
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (location.pathname !== item.path) {
                      navigate(item.path);
                    }
                  }}
                >
                  {t([`COMMON.${item.title}`])}
                </MenuItem>
              );
            })}
          </Menu>
        </SidebarContent>
        <SidebarFooter className="sidebar-footer py-3">
          <SidebarFooterLink href="https://t.me/edutizim" target="_blank">
            {t("COMMON.EDU_SYSTEM")}
            {!collapse && "© 2020"}
          </SidebarFooterLink>
        </SidebarFooter>
      </ProSidebar>
    </SidebarStyle>
  );
};

export default Sidebar;
